/*
**    店铺评级相关
*/
export default [{
    path: 'rating',
    name: 'rating',
    meta: {
      title: '店铺等级'
    },
    component: () =>
      import( /* webpackChunkName: "pop-deliveredWarn" */ '../views/ursit/rating.vue')
  },
  {
    path: 'gradedetails',
    name: 'gradedetails',
    meta: {
      title: '店铺等级详情规则'
    },
    component: () =>
      import( /* webpackChunkName: "pop-deliveredWarn" */ '../views/ursit/gradedetails.vue')
  }
]